// @ts-nocheck
import { ChangeRequestModel } from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangePageContainer";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export type ChangeRequestParameters = {
    changeRequestOrder: ChangeRequestModel;
};

type HandlerType = Handler<ChangeRequestParameters>;

export const DispatchUpdateChangeRequestOrder: HandlerType = props => {
    props.dispatch({
        type: "Greif/PagesReducer/RequestOrderChange/UpdateChangeRequestOrder",
        changeRequestOrder: props.parameter.changeRequestOrder,
    });
};

export const chain = [DispatchUpdateChangeRequestOrder];

const updateChangeRequestOrder = createHandlerChainRunner(chain, "UpdateChangeRequestOrder");
export default updateChangeRequestOrder;
